<template>
  <div class="pa-site-banner">
    <div>
      <img :src="bannerImg" alt="PA Site Banner" class="banner-image" />

      <EgovLink
        :disabled="false"
        label="Official website"
        :newTab="false"
        size="small"
        variant="inline"
        @click="handleLinkClick"
      />

      <p class="pa-vlabel">of the Commonwealth of Pennsylvania</p>

      <EgovModal
        v-if="showModal"
        v-model="showModal"
        icon="ri-government-line"
        title="The .gov means it's official."
        class="egov-modal"
      >
      <template v-slot:content>
        <p>
          Local, state, and federal government websites often end in .gov. Commonwealth of Pennsylvania government
          websites and email systems use 'pennsylvania.gov' or 'pa.gov' at the end of the address. Before sharing
          sensitive or personal information, make sure you're on an official state website.
        </p>
      </template>

      </EgovModal>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import bannerImg from '@/assets/banner-image.png'
import EgovLink from './EgovLink.vue'
import EgovModal from './EgovModal.vue'

const showModal = ref(false)

const handleLinkClick = () => {
  showModal.value = true
}

/*
  TEST HOOK ONLY
  Allows unit tests to trigger modal without relying on EgovLink event system.
*/
const openModal = () => {
  showModal.value = true
}

defineExpose({ openModal })
</script>

<style scoped>
.pa-site-banner {
  background-color: rgba(232, 237, 255, 1);
  width: 100%;
  top: 0;
  left: 0;
  z-index: 9999;
}

.pa-site-banner > div {
  display: flex;
  align-items: center;
  padding: 8px 0px;
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;

  @media (min-width: 0px) {
    padding: 8px 48px !important;
  }

  @media (min-width: 564px) {
    padding: 8px 48px !important;
  }

  @media (min-width: 960px) {
    padding: 8px 48px !important;
  }

 @media (min-width: 1264px) {
    padding: 8px 24px !important;
  }
  @media (min-width: 1464px) {
    padding: 8px 0px !important;
  }
}

.banner-image {
  margin-right: 8px;
  @media (max-width: 760px) {
    scale: 0.75;
  }
  @media (max-width: 565px) {
    scale: 1;
  }
}

.pa-vlabel {
  font-size: 11px;
  font-weight: 600;
  margin-left: 3px;
  color: var(--kds-on-surface);
  opacity: 100%;
}
</style>
